import { AT_MENTION_TRIGGER_CHARACTER } from '../constants';
import { Editor } from 'roosterjs-editor-core';
import { PluginDomEvent, PluginEvent, PluginEventType } from 'roosterjs-editor-types';

export default function atMentionsPluginTrigger(evt: PluginEvent, editor: Editor) {
    if (evt.eventType === PluginEventType.KeyPress) {
        const keyboardEvent = (evt as PluginDomEvent).rawEvent as KeyboardEvent;
        return (
            keyboardEvent.key == AT_MENTION_TRIGGER_CHARACTER ||
            (keyboardEvent.key == '2' && keyboardEvent.shiftKey)
        );
    }
    return false;
}
